<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="security-subtitle security-section-title">
    <svg class="security-section-title__icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2.5 20 6v5.2c0 5-3.4 8.7-8 10.3-4.6-1.6-8-5.3-8-10.3V6l8-3.5Z" />
      <path d="M8.8 11.7 11 13.9l4.5-4.5" />
    </svg>
    <div class="security-section-title__text">{{ title }}</div>
  </div>
</template>

<style scoped lang="scss">
.security-section-title {
  align-items: center;
  display: flex;
  margin-bottom: 12px;
}

.security-section-title__icon {
  fill: none;
  flex: 0 0 34px;
  height: 34px;
  stroke: #474ce6;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
  width: 34px;
}

.security-section-title__text {
  color: #474ce6;
  font-size: 2.5em;
  font-weight: 900;
  letter-spacing: -.05em;
  margin-left: 1rem;
}

@media (max-width: 767px) {
  .security-section-title__text {
    font-size: 2em;
  }
}
</style>
